import { render, staticRenderFns } from "./BookingSuggestion.vue?vue&type=template&id=abe13c8c"
import script from "./BookingSuggestion.vue?vue&type=script&lang=js"
export * from "./BookingSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports